import React from "react";
import { Box } from "../../assets/ui";
import { StyledSectionWrapper, StyledSectionContent } from "./ui";

const TeachersTrainersBanner = () => {
  return (
    <StyledSectionWrapper>
      <StyledSectionContent>
        <Box>
          <p>
            <span>Teacher trainers manegmanet</span>
          </p>
          <h3>Personal trainer management system that brings you customers</h3>
        </Box>
        <img src="./images/teachers-trainers.png" alt="" />
      </StyledSectionContent>
    </StyledSectionWrapper>
  );
};

export default TeachersTrainersBanner;
